import ContentHeader from "../../widgets/contentHeader/ContentHeader"
import RoadWeatherStationReview from "../../widgets/roadWeatherStationReview/RoadWeatherStationReview"

export default function RoadWeatherStationPage() {

    return (
        <>
            <ContentHeader title="Метеостанция" />
            <RoadWeatherStationReview />
        </>
    )
}
